import { createSlice } from "@reduxjs/toolkit";
import { createDelivery } from "../thunks/createDeliveryThunk";

const deliverySlice = createSlice({
  name: "delivery",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    delivery: null,
  },
  reducers: {
    resetCreatePackageStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createDelivery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createDelivery.fulfilled, (state, action) => {
        state.delivery = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(createDelivery.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetCreatePackageStatus } = deliverySlice.actions;
export default deliverySlice.reducer;
